import { TrainingStep } from "../../components/common/TrainingGuide";

const marketplaceSteps: TrainingStep[] = [
  {
    title: "Marketplace (Veridian Ginie) Overview",
    description:
      "The Marketplace module manages third-party sellers who want to list products on the AFAQ platform. It tracks seller registration, tier status, onboarding progress, and commissions.",
    tip: "Veridian Ginie is the internal codename for the marketplace. Keep it confidential externally.",
  },
  {
    title: "Registering a New Seller",
    description:
      "Click '+ Register Seller'. Enter the business name, contact details, trade licence number, and product categories. The system assigns a Seller ID and sends a welcome message via WhatsApp.",
    tip: "Always verify the trade licence number before approving — UAE law requires it for B2B resellers.",
  },
  {
    title: "Tier System",
    description:
      "Sellers are tiered: Bronze → Silver → Gold → Platinum. Tier is calculated from monthly GMV (Gross Merchandise Value). Higher tiers get lower commission rates and priority placement.",
    tip: "Review tier upgrades monthly. Sellers close to a tier threshold may need a nudge — check their GMV trend.",
  },
  {
    title: "Onboarding Steps",
    description:
      "Each new seller goes through 5 onboarding steps: Document Upload → Contract Sign → Product Listing → Test Order → Go Live. The progress bar shows where they are. Incomplete steps block Go Live.",
    tip: "The AI writing assistant can help draft personalised onboarding emails for stuck sellers.",
  },
  {
    title: "Commission Tracking",
    description:
      "Commissions are deducted automatically from each seller's payout. The rate varies by tier and category. You can view a seller's commission history and dispute any line in the detail drawer.",
    tip: "Export commission statements as PDF at month-end — sellers need these for their VAT filings.",
  },
  {
    title: "Marketplace Analytics",
    description:
      "The Analytics tab shows top-selling categories, seller performance rankings, GMV trend, and payout calendar. Use this to decide which sellers to promote and which to coach.",
    tip: "Cross-reference marketplace data with Pricing Intelligence — if a seller is underpricing ENZO, flag it.",
  },
];

export default marketplaceSteps;
